export default {
  surveys: [],
  pagination: {},
  survey: {}
}
